
<template>
    <div class="product-selector">
        <semrush-branded v-if="type == 'semrush_keyword_rank_branded_2'" :id="id"  :preview="preview" :preload="preload" />
        <semrush-non-branded v-if="type == 'semrush_keyword_rank_nonbranded_2'" :id="id"  :preview="preview" :preload="preload" />
        <dataforseo-branded v-if="type == 'dataforseo_branded'" :id="id"  :preview="preview" :preload="preload" />
        <dataforseo-non-branded v-if="type == 'dataforseo_nonbranded'" :id="id"  :preview="preview" :preload="preload" />
        <uptime v-if="type == 'uptime2'" :id="id" :preview="preview" :preload="preload" />
        <linked-in v-if="type == 'linkedin'" :id="id" :preview="preview" :preload="preload" />
        <custom v-if="type == 'custom'" :id="id" :preview="preview" :preload="preload" />
        <sari v-if="type == 'sari'" :id="id" :preview="preview" :preload="preload" />
        <ofks v-if="type == 'ofks'" :id="id" :preview="preview" :preload="preload" />
        <primalgo v-if="type == 'primalgo'" :id="id" :preview="preview" :preload="preload" />
        <lsi v-if="type == 'lsi'" :id="id" :preview="preview" :preload="preload" />
        <cleverreach v-if="type == 'cleverreach'" :id="id" :preview="preview" :preload="preload" />
        <impaxis v-if="type == 'impaxis' || type.startsWith('impaxis.')" :id="id" :preview="preview" :preload="preload" />
    </div>
</template>

<script>
import products from "@/services/products";
import SemrushBranded from "./semrush/Branded.vue";
import SemrushNonBranded from "./semrush/NonBranded.vue";
import DataforseoBranded from "./dataforseo/Branded.vue";
import DataforseoNonBranded from "./dataforseo/NonBranded.vue";
import Uptime from "./uptime/Uptime.vue";
import Sari from "./sari/Sari.vue";
import Ofks from "./ofks/Ofks.vue";
import LinkedIn from "./linkedin/LinkedIn.vue";
import Custom from "./custom/Custom.vue";
import Primalgo from "./primalgo/Primalgo.vue";
import Lsi from "./lsi/Lsi.vue";
import Cleverreach from "./cleverreach/Cleverreach.vue";
import Impaxis from "./impaxis/Impaxis.vue";

export default {
    props: {
        id: {},
        preview: {
            type: Boolean,
            default: false
        },
        preload: {
            type: Object,
            default: null
        }
    },
    components: {
        Uptime,
        LinkedIn,
        Custom,
        Sari,
        SemrushBranded,
        SemrushNonBranded,
        Ofks,
        Primalgo,
        Lsi,
        Cleverreach,
        DataforseoBranded,
        DataforseoNonBranded,
        Impaxis
    },
    computed: {
        type() {
            return products.get(this.id).type;
        }
    }
}
</script>
